// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__MPtHK","disabled":"Pagination_disabled__1hTgK","selected":"Pagination_selected__1mAeQ"};